module.exports = __webpack_public_path__ + "img/specialties.dd2a45a6.svg";